web = window.web = window.web || {};
web.credits = window.web.credits = window.web.credits || {};
web.creditsSection = window.web.creditsSection = window.web.creditsSection || {};

var $ = require('jquery');

web.creditsSectionSection = module.exports = function($context, options) {
    var t = this;
    t.instanceState = 'constructed';

    t.defaults = {};

    t.options = $.extend({}, t.defaults, options);

    t.$context = $context;

    t.active = false;

    t.ACTIVE_CLASS = 'active';
};

web.creditsSectionSection.prototype = {
    init: function(){
        var t = this;
        t._bindEvents();
    },

    setContext: function($context) {
        var t = this;

        t.$context = $context;
    },

    _bindEvents: function() {
        var t = this;

        t.$context.on("click", function(e){
           var $this = $(this);

            $(t).trigger({
                type: "click",
                sectionInstance: t
            });

            e.preventDefault();
        });
    },

    setActive: function(active) {
        var t = this;
        t.active = active;


        var eventName = "iAmNotActiveNow";
        if (active) {
            eventName = "iAmActiveNow";
        }

        $(t).trigger({
            type: eventName,
            iAm: t,
            myId: t.getId(),
            myUrl: t.getUrl()
        })

    },

    getActive: function(){
        var t = this;

        return t.active;
    },

    isActive: function(){
        var t = this;

        return t.getActive();
    },

    redraw: function(){
        var t = this;

        if (t.isActive())  {
            t.$context.addClass(t.ACTIVE_CLASS);
        } else {
            t.$context.removeClass(t.ACTIVE_CLASS);
        }
    },

    getId: function(){
        var t = this;

        return t.$context.data("sectionId");
    },

    getUrl: function(){
        var t = this;

        return t.$context.data("sectionUrl");
    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/credits/section/Section.js